var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ModalMantenedor",
    {
      attrs: { show: _vm.show },
      model: {
        value: _vm.show,
        callback: function($$v) {
          _vm.show = $$v
        },
        expression: "show"
      }
    },
    [
      _c(
        "CabeceraModal",
        {
          attrs: { titulo: "Cuadraturas en Terreno" },
          on: { cerrar: _vm.closeModal }
        },
        [
          _c(
            "div",
            {
              staticClass: "numero_sim",
              staticStyle: {
                "letter-spacing": "0.02em",
                "white-space": "nowrap",
                overflow: "hidden",
                "text-overflow": "ellipsis",
                "margin-top": "16px"
              }
            },
            [
              _c("div", {
                staticClass: "boton_crear",
                staticStyle: { height: "37px" }
              })
            ]
          )
        ]
      ),
      _c(
        "v-card",
        { attrs: { height: "55px", flat: "" } },
        [
          _c(
            "v-bottom-nav",
            {
              attrs: {
                value: true,
                active: _vm.pasos.informacionGeneral.step,
                absolute: "",
                color: "transparent"
              },
              on: {
                "update:active": function($event) {
                  return _vm.$set(_vm.pasos.informacionGeneral, "step", $event)
                }
              }
            },
            [
              _c(
                "v-btn",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.pasos.informacionGeneral.visible,
                      expression: "pasos.informacionGeneral.visible"
                    }
                  ],
                  attrs: {
                    color: "primary",
                    flat: "",
                    value: _vm.pasos.informacionGeneral.step
                  },
                  on: { click: _vm.handleInfoGeneral }
                },
                [
                  _c("span", [_vm._v("Detalle")]),
                  _c("v-icon", [_vm._v("info")])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showInfo,
              expression: "showInfo"
            }
          ],
          staticClass: "cardnew",
          attrs: { align: "center" }
        },
        [
          _c("br"),
          _c(
            "div",
            { staticClass: "orden_compra", attrs: { align: "center" } },
            [
              _c(
                "v-flex",
                { attrs: { md10: "" } },
                [
                  _c(
                    "v-card",
                    { staticClass: "rounded-card" },
                    [
                      _c(
                        "v-form",
                        {
                          ref: "form",
                          staticClass: "col-md-12",
                          attrs: { "lazy-validation": "" }
                        },
                        [
                          _c(
                            "v-container",
                            { attrs: { "grid-list-md": "" } },
                            [
                              _c("h3", [
                                _vm._v(
                                  "\n                Detalle Cuadratura en terreno\n              "
                                )
                              ]),
                              _c(
                                "div",
                                {
                                  staticClass: "layout row wrap",
                                  staticStyle: {
                                    "padding-right": "0px",
                                    "padding-left": "10px"
                                  }
                                },
                                [
                                  _c("div", {
                                    staticClass: "flex xs12 sm8 md8",
                                    attrs: { align: "lef" }
                                  }),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "flex xs12 sm2 md2",
                                      attrs: { align: "lef" }
                                    },
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            flat: "",
                                            small: "",
                                            color: "primary"
                                          },
                                          on: { click: _vm.btn_ver_evidencias }
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            {
                                              staticClass: "importExportBtnIcon"
                                            },
                                            [_vm._v("photo_camera")]
                                          ),
                                          _vm._v("  \n                    "),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "importExportBtnTexto",
                                              staticStyle: {
                                                "margin-right": "30px"
                                              }
                                            },
                                            [_vm._v("Ver Evidencias")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "flex xs12 sm2 md2",
                                      attrs: { align: "right" }
                                    },
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            flat: "",
                                            small: "",
                                            color: "primary"
                                          },
                                          on: { click: _vm.btn_exportar }
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            {
                                              staticClass: "importExportBtnIcon"
                                            },
                                            [_vm._v("cloud_download")]
                                          ),
                                          _vm._v("  \n                    "),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "importExportBtnTexto",
                                              staticStyle: {
                                                "margin-right": "30px"
                                              }
                                            },
                                            [_vm._v("Exportar csv")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ]
                              ),
                              _c("v-card", { attrs: { flat: "" } }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "gridcard2 rounded-card2 orden_compra2"
                                  },
                                  [
                                    _c("MantenedorGridSinCodigo", {
                                      attrs: {
                                        "grid-options": _vm.gridOptions,
                                        "funcionalidad-id": _vm.funcionalidad
                                      }
                                    })
                                  ],
                                  1
                                )
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _c(
        "v-dialog",
        {
          attrs: { width: "50%" },
          model: {
            value: _vm.showEvidenciasDialog,
            callback: function($$v) {
              _vm.showEvidenciasDialog = $$v
            },
            expression: "showEvidenciasDialog"
          }
        },
        [
          _c(
            "v-toolbar",
            { attrs: { dark: "", color: "primary" } },
            [
              _c(
                "v-toolbar-title",
                {
                  staticStyle: {
                    "font-size": "17px",
                    "margin-left": "10px !important"
                  }
                },
                [_vm._v("Evidencias")]
              )
            ],
            1
          ),
          _c("v-divider"),
          _c("v-card", { attrs: { id: "bodyDialogInfo" } }, [
            _c(
              "div",
              {
                staticClass:
                  "layout row wrap fotos-modal-ver-detalle-cuadratura"
              },
              _vm._l(_vm.LISTA_FOTOS, function(foto) {
                return _c("figure", { key: foto.index }, [
                  _c("img", {
                    staticStyle: { margin: "5px 10px" },
                    attrs: { src: foto }
                  })
                ])
              }),
              0
            )
          ])
        ],
        1
      ),
      _vm.showReporteGenerado
        ? _c("div", { staticClass: "wrap-evidencia" }, [
            _c(
              "div",
              { staticClass: "modalEnvio", attrs: { id: "myModal2" } },
              [
                _c("div", { staticClass: "modalEnvio-content" }, [
                  _c(
                    "div",
                    [
                      _c("div", { staticClass: "titleEvidencia" }, [
                        _c("h2", { staticClass: "importExportBtnIcon" }, [
                          _vm._v("Reporte Solicitado")
                        ])
                      ]),
                      _c(
                        "div",
                        {
                          staticClass: "buttonClose buttonCloseEvidencia",
                          attrs: { align: "right" }
                        },
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: { flat: "", small: "", color: "primary" },
                              on: {
                                click: function($event) {
                                  return _vm.closeReporte()
                                }
                              }
                            },
                            [
                              _c(
                                "v-icon",
                                { staticClass: "importExportBtnIcon" },
                                [_vm._v("close")]
                              ),
                              _vm._v("  \n              "),
                              _c(
                                "span",
                                { staticClass: "importExportBtnTexto" },
                                [_vm._v("Cerrar")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c("v-flex", { attrs: { sm12: "", md12: "" } }, [
                        _c("div", { staticClass: "text-sm-center" }, [
                          _c("p", { staticStyle: { "margin-top": "40px" } }, [
                            _vm._v(_vm._s(_vm.texto_reporte))
                          ])
                        ]),
                        _c("div", { staticClass: "text-sm-center" }, [
                          _c(
                            "p",
                            { staticStyle: { "margin-top": "40px" } },
                            [
                              _vm._v(
                                "\n                Puede ver sus reportes en el menú\n                "
                              ),
                              _c(
                                "router-link",
                                {
                                  staticStyle: {
                                    cursor: "pointer",
                                    "font-size": "13px"
                                  },
                                  attrs: {
                                    "active-class": "router-link-active",
                                    to: "/conecta-reportes"
                                  }
                                },
                                [_vm._v("Informes")]
                              )
                            ],
                            1
                          )
                        ])
                      ])
                    ],
                    1
                  )
                ])
              ]
            )
          ])
        : _vm._e(),
      _c("appconfirmacion", {
        attrs: {
          show: _vm.mostrarModalCONFIRMARdet,
          titulo: "Confirmación",
          mensaje: _vm.Modal_confirmar_TEXTOdet,
          textoBtnSi: _vm.$t("mensajes.crud.crear.btnAceptar"),
          textoBtnNo: _vm.$t("mensajes.crud.crear.btnCancelar")
        },
        on: {
          modalConfirmationEmit: function($event) {
            return _vm.confirmCallbackdet($event)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }